<script>
import Banner from '../components/PageBanner';
import TabMenu from '../components/PageTabMenu';
import Tab from '../components/PageTab';
import Spinner from '../components/Spinner';
import Section from '../components/PageSection';
import PhaseRentab from '../components/accueil/PhaseRentab';
// import Separatif from '../components/Separatif';
import SelectCoeff from '../components/SelectCoeff';
import Footer from '../components/Footer';
import ScaleAdjuster from '../components/accueil/scaleAdjuster.vue';


export default {
  name: 'PageAccueil',
  components:{
    Banner,
    TabMenu,
    Tab,
    Spinner,
    Section,
    PhaseRentab,
    // Separatif,
    SelectCoeff,
    Footer,
    ScaleAdjuster
},
  data(){
    return {
        //Quelque soit les widgets
        fullyLoaded: false,

        //Rentabilité par phases
        phasesEnCours: [],
        errCoeffs: [],
        alphaFactured: 0, //le coefficient pour passer des euros à la largeur de la barre sur le graphique
        alphaContract: 0,
        tthonos: 0,
        ttfactured:0,
        scaleMultiplayer:0
    }
  },
  async mounted(){
    const promisePhases = this.$axios.get('pageAcceuil/rentabiliteParPhases/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      let maxfactured = 0
      let maxHonos = 0
        this.phasesEnCours = response.data.phases;
        this.errCoeffs = response.data.errCoeffs;
        console.log(this.phasesEnCours)
        if(this.phasesEnCours){
            for (let phase of this.phasesEnCours){
              if(phase.factured > maxfactured){
                maxfactured = phase.factured
              }
              if(phase.honos > maxHonos){
                maxHonos = phase.honos
              }
              this.tthonos+= phase.honos
              this.ttfactured+= phase.factured
            }
            this.alphaFactured =  100 /maxfactured
            this.alphaContract = 100 / maxHonos 
            
        }
    })
    .catch(err => this.alert(err))

    await Promise.all([promisePhases])
    this.fullyLoaded = true
  },
  methods:{
    routeTo(projetId){
        //Id du projet, pas de la phase
        this.$router.push('/projet/' + projetId + '/analyse/');
    },

    //Rentabilité par phases
    err(phaseId){
        return this.errCoeffs.filter(e => e.phaseId == phaseId && e._id == this.$store.state.auth.currentCoeff)
    },
    changeScaleMultiplier(data){
        this.scaleMultiplayer = data
    }
  }
}
</script>


<template>
    <div class="page-main">
        <Banner bannerImage="bannerAgence"/>

        <TabMenu>
            <template v-slot:body>
                <Tab text="Tableau de bord"  route="/accueil"  customWidth=160 />
            </template>
        </TabMenu>
        <div v-if="!fullyLoaded" class="spinner"><Spinner/></div>
        <div v-else class="page-main-container">
            <div class="flex-line">
                <div id="bienvenue" class="infos">
                    <div class="infos-title">Bienvenue sur Sphem.fr</div>
                    <div class="infos-text">
                    Nouveautés Octobre 2022 :
                        <ul class="infos-liste">
                            <li>Modification du nom des projets : [Nom + localisation] ont été remplacés par [Titre + Sous-titre]. Ces deux informations sont désormais utilisées dans la liste des projets dans les temps passés.</li>
                            <li>Ajustement de la taille des polices dans la carte d'identité des projets.</li>
                        </ul>
                    </div>
                </div>
                <SelectCoeff id="selectCoeff" />
                <ScaleAdjuster @adjustement="changeScaleMultiplier"/>
            </div>

            <Section text="Rentabilité des projets en cours" class="section">
                <template v-slot:body>
                    <div>
                        <div v-for="(phase) in phasesEnCours" :key="phase._id">
                            <!-- <Separatif v-if="index!= 0" /> -->
                            <!-- Ajouter (phase, index) dans le v-for -->
                            <PhaseRentab :name="phase.title" :phase="phase.subtitle" :_id="phase.projectId" :tthonos="tthonos" :honos="phase.honos" :ttfactured= "ttfactured" :factured="phase.factured"  :depenses="phase.depenses [$store.state.auth.currentCoeff]" :err="err(phase._id)" :alphaFactured="alphaFactured" :alphaHonos="alphaContract" :scaleMultiplayer="scaleMultiplayer"  @clicked-link="routeTo(phase.projectId)" />
                        </div>
                    </div>
                </template>
            </Section>
        </div>

        <Footer />
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

@include page-main;

.section{
    margin: 10px 0 0 0;
}

.infos{
    &-title{
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 1px;
        color: $main;
        margin: 0 0 10px 0;
    }

    &-text{
        @include myFont;
        color: $black-bolder;
        font-size: 13px;
    }

    &-liste{
        margin: 5px 0;
    }
}

.flex-line{
    display: flex;
}

#bienvenue{
    flex: 1;
}

#selectCoeff{
    margin: 0 0 0 25px;
    width: 200px;
}

</style>
